import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { DeviceContainer, DeviceWrapper, DeviceText, DeviceOptions } from './styles';
import { H4, H5 } from '../../components/Typography/styles';
import playstore from '../../assets/images/playstore.png';
import appstore from '../../assets/images/appstore.png';
import getDeviceType from '../../helpers/userAgent';
import Copyright from '../../components/Copyright';
import colors from '../../assets/styles/colors';

const DevicePage = () => {
  const history = useHistory();

  useEffect(() => {
    if (getDeviceType() === "desktop") {
      history.push('/login');
    }
  }, [])

  return (
    <DeviceContainer id="device-page">
      <DeviceWrapper>
        <H4 color={colors.bgSuccess}>Use our mobile App to a better performance!</H4>
        <DeviceText>
          <H5 color="#2A2C31">Please, select your App store</H5>
        </DeviceText>
        <DeviceOptions>
          <a href="https://www.google.com.br/">
            <img src={playstore} alt="Playstore App" />
          </a>
          <a href="https://www.google.com.br/">
            <img src={appstore} alt="Appstore App" />
          </a>
        </DeviceOptions>
      </DeviceWrapper>
      <Copyright />
    </DeviceContainer>
  )
}

export default DevicePage;
